(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingPassengerDetails',
	};

	var $form;

	var _loadClientDetails,
	    _loadPassengerTitles,
	    _loadPastPassengerNumbers,
	    _loadPhoneNumbers,
	    _resetPassenger,
	    _loadPassengerAddresses,
	    _loadPassengerIataStates;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		var $jForm;

		if (response.data.response_code === "age_mismatch") {
			Adzuki.CustomConfirm({
				body   : response.data.message,
				confirm: function yes() {
					$jForm = $('form[name="' + form.name + '"]');

					// set hidden input indicating that the user wants to ignore the age mismatch, so we do not throw a confirm again
					$jForm.find('.age_mismatch_proceed').val(1);

					$jForm.submit();
				}
			});
		}
	};

	form.load = function load()
	{
		$form = $(form.element);

		$form.find('.pd-entrytype').on('change', function change(e) {
			var $entrytype = $(this),
			    $passenger;

			switch ($entrytype.val()) {
				case '':
					_resetPassenger($entrytype.data('pd-index'));
					break;
				case 'existing':
					_resetPassenger($entrytype.data('pd-index'));

					$passenger = $form.find('.passenger-details-' + $entrytype.data('pd-index'));
					$passenger.find('.pd-entrytype-div').addClass('hidden');
					$passenger.find('.pd-existingname-div').removeClass('hidden');
					$passenger.find('.pd-existingname').focus();
					break;
				default:
					_loadClientDetails($entrytype.data('pd-index'), $entrytype.val());
					break;
			}
		});

		$form.find('.pd-existingname').each(function iterator(i, input) {
			Adzuki.Typeahead(
				input,
				'/Clients/search',
				function select(item, $self, typeahead) {
					typeahead.setHiddenValue(item.id);

					_loadClientDetails(i, item.id);
				}
			);
		});

		$form.find('.pd-existingname').on('ta.reset', function reset(e) {
			_resetPassenger($(this).data('pd-index'));
		});

		$form.find('.pd-select-entrytype').click(function click(e) {
			var $passenger = $form.find('.passenger-details-' + $(this).data('pd-index'));

			e.preventDefault();

			$passenger.find('.pd-existingname-div .reset-typeahead a').trigger('click');
			$passenger.find('.pd-entrytype').val('');
			$passenger.find('.pd-existingname-div').addClass('hidden');
			$passenger.find('.pd-entrytype-div').removeClass('hidden');
		});

		$form.find('.pd-primary').on('change', function change(e) {
			var $primary = $(this);

			e.preventDefault();

			if ($primary.val() === 'Y') {
				$form.find('.pd-primary[value="N"]').prop('checked', true);
				$form.find('.pd-primary[value="Y"]').parent().removeClass('active');
				$form.find('.pd-primary[value="N"]').parent().addClass('active');

				$primary.prop('checked', true);
				$primary.parent().next().removeClass('active');
				$primary.parent().addClass('active');
			}
		});

		$form.find('.pd-gendercode').on('change', function change(e) {
			_loadPassengerTitles($(this).data('pd-index'));
		});

		$form.find('.pd-phoneno').on('change', function change(e) {
			var $phoneno   = $(this),
				$passenger = $form.find('.passenger-details-' + $phoneno.data('pd-index'));

			if ($phoneno.val() === 'manual') {
				$passenger.find('.pd-phoneno-div').addClass('hidden');
				$passenger.find('.pd-phonenomanual-div').removeClass('hidden');
				$passenger.find('.pd-phonenomanual').focus();
			}
		});

		$form.find('.pd-select-phoneno').on('click', function change(e) {
			var $passenger = $form.find('.passenger-details-' + $(this).data('pd-index'));

			e.preventDefault();

			$passenger.find('.pd-phoneno').val('');
			$passenger.find('.pd-phonenomanual-div').addClass('hidden');
			$passenger.find('.pd-phoneno-div').removeClass('hidden');
		});

		$form.find('.pd-phonenomanual').on('keyup', function keyup(e) {
			var $phonenomanual   = $(this),
			    formatted_number;

			if (typeof $phonenomanual.data('old-value') !== 'undefined' && $phonenomanual.val() === $phonenomanual.data('old-value')) {
				return;
			}

			formatted_number = $phonenomanual.val().replace(/[^0-9]/g, '');

			if (formatted_number.length >= 7) {
				formatted_number = formatted_number.substr(0, 3) + '-' + formatted_number.substr(3, 3) + '-' + formatted_number.substr(6, 4);
			} else if (formatted_number.length >= 4) {
				formatted_number = formatted_number.substr(0, 3) + '-' + formatted_number.substr(3, 3);
			}

			$phonenomanual.val(formatted_number);
			$phonenomanual.data('old-value', formatted_number);
		});

		$form.find('.pd-pastpassengerno').on('change', function change(e) {
			var $pastpassengerno   = $(this),
				$passenger = $form.find('.passenger-details-' + $pastpassengerno.data('pd-index'));

			if ($pastpassengerno.val() === 'manual') {
				$passenger.find('.pd-pastpassengerno-div').addClass('hidden');
				$passenger.find('.pd-pastpassengernomanual-div').removeClass('hidden');

				$passenger.find('.pd-pastpassengernomanual').focus();
			}
		});

		$form.find('.pd-select-pastpassengerno').on('click', function change(e) {
			var $passenger = $form.find('.passenger-details-' + $(this).data('pd-index'));

			e.preventDefault();

			$passenger.find('.pd-pastpassengerno').val('');

			$passenger.find('.pd-pastpassengernomanual-div').addClass('hidden');
			$passenger.find('.pd-pastpassengerno-div').removeClass('hidden');
		});

		$form.find('.pd-iatacountry').on('change', function change(event) {
			var index = $(this).data('pd-index');

			_loadPassengerIataStates(index);
		});

		$form.find('.clickable-row').on('click', function click(e) {
			if ($(e.target).prop('nodeName') !== 'INPUT') {
				e.preventDefault();

				$($(this).find('input')[0]).trigger('click');
			}
		});

		$form.find('.pd-clientid').each(function iterator(i, input) {
			var $clientid  = $(this),
			    index      = $clientid.data('pd-index'),
			    $passenger = $form.find('.passenger-details-' + index);

			if ($clientid.val() === '') {
				_resetPassenger(index);
			} else {
				if ($passenger.find('.pd-entrytype').val() === 'existing') {
					$passenger.find('.pd-entrytype-div').addClass('hidden');
					$passenger.find('.pd-existingname-div .reset-typeahead').removeClass('hidden');
					$passenger.find('.pd-existingname-div').removeClass('hidden');
				}

				_loadPassengerTitles(index);
				_loadPhoneNumbers(index);
				_loadPastPassengerNumbers(index);
				_loadPassengerIataStates(index);
				_loadPassengerAddresses(index, $clientid.val());
			}

			$('.toggle-pax-' + index + '-address').on('click', function onPlusClick(event) {
				var $anchor = $(this);
				var $icon   = $anchor.find('.fa').first();

				event.preventDefault();

				if ($icon.hasClass(Adzuki.FaIcon.getIconStyleName('collapse'))) {
					$icon.removeClass(Adzuki.FaIcon.getIconStyleName('collapse'))
						 .addClass(Adzuki.FaIcon.getIconStyleName('expand'));
				} else {
					$icon.removeClass(Adzuki.FaIcon.getIconStyleName('expand'))
						 .addClass(Adzuki.FaIcon.getIconStyleName('collapse'));
				}
			});
		});

		if ($form.find('.dining-radio').length === 1) {
			$($form.find('.dining-radio')[0]).trigger('click');
		}

		if ($form.find('.table-radio').length === 1) {
			$($form.find('.table-radio')[0]).trigger('click');
		}

		if ($form.find('.bed-type-radio').length === 1) {
			$($form.find('.bed-type-radio')[0]).trigger('click');
		}
	};

	_loadClientDetails = function _loadClientDetails(index, client_id)
	{
		var $passenger = $form.find('.passenger-details-' + index);

		_resetPassenger(index);

		$passenger.find('.btn-radio').removeClass('disabled');
		$passenger.find('.form-control:not(".pd-entrytype,.pd-passengertitle")').prop('disabled', false);
		$passenger.find('.pd-clientid').val(client_id);

		Adzuki.Ajax.get('/CruiseBooking/loadClientDetails/' + client_id).then(function success(client_details) {
			var dob = $passenger.find('.pd-dob').data('DateTimePicker');

			$passenger.find('.pd-gendercode').val(client_details['genderCode']);
			$passenger.find('.pd-passengertitle').data('value', client_details['passengerTitle']);
			$passenger.find('.pd-firstname').val(client_details['firstName']);
			$passenger.find('.pd-middlename').val(client_details['middleName']);
			$passenger.find('.pd-lastname').val(client_details['lastName']);

			if ($passenger.find('.pd-age').length > 0) {
				$passenger.find('.pd-age').val(client_details['age']);
			}

			if (client_details['dob'] !== null) {
				dob.date(client_details['dob']);
			}

			if ($passenger.find('.pd-email').length > 0) {
				$passenger.find('.pd-email').val(client_details['email']);
			}

			_loadPassengerTitles(index);
			_loadPhoneNumbers(index);
			_loadPastPassengerNumbers(index);
			_loadPassengerIataStates(index);
			_loadPassengerAddresses(index, client_id);
		});
	};

	_loadPassengerTitles = function _loadPassengerTitles(index)
	{
		var $passenger      = $form.find('.passenger-details-' + index),
		    $passengertitle = $passenger.find('.pd-passengertitle'),
		    gender_code     = $passenger.find('.pd-gendercode').val();

		$passengertitle.empty();
		$passengertitle.prop('disabled', true);

		if (gender_code === '') {
			return;
		}

		$passengertitle.prop('disabled', false);

		Adzuki.Ajax.get('/CruiseBooking/loadPassengerTitles/' + gender_code).then(function success(passenger_titles) {
			$.each(passenger_titles, function loadPassengerTitles(key, passenger_title) {
				$passengertitle.append($('<option>').text(passenger_title).attr('value', key));
			});

			$passengertitle.val('');

			if (typeof $passengertitle.data('value') !== 'undefined') {
				$passengertitle.val($passengertitle.data('value'));
				$passengertitle.removeAttr('data-value');
				$passengertitle.removeData('value');
			}

			if ($passengertitle.val() === null) {
				if (gender_code === 'F') {
					$passengertitle.val('MS');
				} else {
					$passengertitle.val('MR');
				}
			}
		});
	};

	_loadPastPassengerNumbers = function _loadPastPassengerNumbers(index)
	{
		var $passenger       = $form.find('.passenger-details-' + index),
		    $pastpassengerno = $passenger.find('.pd-pastpassengerno');

		$pastpassengerno.empty();
		$pastpassengerno.prop('disabled', false);

		Adzuki.Ajax.get('/CruiseBooking/loadPastPassengerNumbers/' + $passenger.find('.pd-clientid').val()).then(function success(past_passenger_numbers) {
			var optgroup;

			$.each(past_passenger_numbers, function loadPastPassengerNumberGroups(i, past_passenger_number_group) {
				optgroup = $('<optgroup>');
				optgroup.attr('label', past_passenger_number_group.name);

				$.each(past_passenger_number_group.numbers, function loadPastPassengerNumbers(i, past_passenger_number) {
					optgroup.append($('<option>').text(past_passenger_number.name).attr('value', past_passenger_number.number));
				});

				$pastpassengerno.append(optgroup);
			});

			if (past_passenger_numbers.length > 1) {
				$passenger.find('.pd-pastpassengernomanual-div').addClass('hidden');
				$passenger.find('.pd-select-pastpassengerno').removeClass('hidden');
				$passenger.find('.pd-pastpassengerno-div').removeClass('hidden');

				$pastpassengerno.val('');

				if (typeof $pastpassengerno.data('value') !== 'undefined') {
					if ($pastpassengerno.data('value') !== '') {
						$pastpassengerno.val($pastpassengerno.data('value'));

						if ($pastpassengerno.val() === null) {
							$passenger.find('.pd-pastpassengerno-div').addClass('hidden');
							$pastpassengerno.val('manual');

							$passenger.find('.pd-pastpassengernomanual').val($pastpassengerno.data('value'));
							$passenger.find('.pd-pastpassengernomanual-div').removeClass('hidden');
						}
					}

					$pastpassengerno.removeAttr('data-value');
					$pastpassengerno.removeData('value');
				}
			} else {
				$passenger.find('.pd-select-pastpassengerno').addClass('hidden');
				$passenger.find('.pd-pastpassengerno-div').addClass('hidden');
				$pastpassengerno.val('manual');

				if (typeof $pastpassengerno.data('value') !== 'undefined') {
					$passenger.find('.pd-pastpassengernomanual').val($pastpassengerno.data('value'));
					$pastpassengerno.removeAttr('data-value');
					$pastpassengerno.removeData('value');
				}

				$passenger.find('.pd-pastpassengernomanual-div').removeClass('hidden');
			}
		});
	};

	_loadPhoneNumbers = function _loadPhoneNumbers(index)
	{
		var $passenger = $form.find('.passenger-details-' + index),
		    $phoneno   = $passenger.find('.pd-phoneno');

		$phoneno.empty();
		$phoneno.prop('disabled', false);

		$passenger.find('.pd-select-phoneno').removeClass('hidden');

		Adzuki.Ajax.get('/CruiseBooking/loadPhoneNumbers/' + $passenger.find('.pd-clientid').val()).then(function success(phone_numbers) {
			var optgroup_count = 0,
				optgroup;

			$.each(phone_numbers, function loadPhoneNumberGroups(i, phone_number_group) {
				optgroup = $('<optgroup>');
				optgroup.attr('label', phone_number_group.name);

				$.each(phone_number_group.numbers, function loadPhoneNumbers(i, phone_number) {
					optgroup.append($('<option>').text(phone_number.name).attr('value', phone_number.number));
				});

				$phoneno.append(optgroup);

				optgroup_count++;
			});

			$phoneno.val('');

			if (typeof $phoneno.data('value') !== 'undefined') {
				if ($phoneno.data('value') !== '' || optgroup_count === 1) {
					$phoneno.val($phoneno.data('value'));

					if ($phoneno.val() === null) {
						if (optgroup_count === 1) {
							$passenger.find('.pd-select-phoneno').addClass('hidden');
						}

						$passenger.find('.pd-phoneno-div').addClass('hidden');
						$phoneno.val('manual');

						$passenger.find('.pd-phonenomanual').val($phoneno.data('value'));
						$passenger.find('.pd-phonenomanual-div').removeClass('hidden');
					}
				}

				$phoneno.removeAttr('data-value');
				$phoneno.removeData('value');
			}
		});
	};

	_loadPassengerIataStates = function _loadPassengerIataStates(index)
	{
		var $passenger      = $form.find('.passenger-details-' + index),
		    $state_select   = $passenger.find('.pd-iatastateprovince'),
		    $country_select = $passenger.find('.pd-iatacountry');

		$state_select.empty().append('<option selected="1"></option>');

		if ($country_select.val() !== '') {
			Adzuki.Ajax.get('/CruiseBooking/loadIataStateProvinces/' + $country_select.val())
			.then(function success(iata_states) {
				if ($.isEmptyObject(iata_states)) {
					$state_select.prop('disabled', true);
				} else {
					$state_select.prop('disabled', false);

					$.each(iata_states, function onEachState(state_code, state) {
						var markup = '';
							markup += '<option value="' + state_code + '">';
							markup += state;
							markup += '</option>';

						$state_select.append(markup);
					});
				}

				if ($state_select.data('value')) {
					$state_select.val($state_select.data('value'));
				}
			});
		}
	};

	_loadPassengerAddresses = function _loadPassengerAddresses(index, client_id)
	{
		var $passenger      = $form.find('.passenger-details-' + index),
		    $address_select = $passenger.find('.pd-address');

		$address_select.empty().append('<option selected="1"></option>');

		if (client_id === 'new' || client_id === 'existing') {
			return;
		}

		Adzuki.Ajax.get('/ClientAddresses/getAddressesByClientId/' + client_id)
		.then(function success(client_addresses) {
			if ($.isEmptyObject(client_addresses)) {
				$address_select.prop('disabled', true);
			} else {
				$address_select.prop('disabled', false);

				$.each(client_addresses, function onEachAddress(address_id, address) {
					var markup = '';
						markup += '<option value="' + address_id + '">';
						markup += address;
						markup += '</option>';

					if (address !== '') {
						$address_select.append(markup);
					}
				});

				$address_select.off().on('change', function onAddressChange(event) {
					var address_id = $(this).val();

					if (address_id === '') {
						$passenger.find('.pd-streetaddress1').val('');
						$passenger.find('.pd-streetaddress2').val('');
						$passenger.find('.pd-city').val('');
						$passenger.find('.pd-iatastateprovince').val('');
						$passenger.find('.pd-zippostalcode').val('');
					} else {
						Adzuki.Ajax.get('/ClientAddresses/_ajaxGetAddress/' + address_id)
						.then(function success(client_address) {
							$passenger.find('.pd-streetaddress1').val(client_address.address1);
							$passenger.find('.pd-streetaddress2').val(client_address.address2);
							$passenger.find('.pd-city').val(client_address.city);
							$passenger.find('.pd-zippostalcode').val(client_address.zip);

							if (client_address.state_id) {
								Adzuki.Ajax.get('/States/getIsoById/' + client_address.state_id)
								.then(function success(iso_code) {
									$passenger.find('.pd-iatastateprovince').val(iso_code);
								});
							}
						});
					}
				});
			}
		});
	};

	_resetPassenger = function _resetPassenger(index)
	{
		var $passenger = $form.find('.passenger-details-' + index),
		    dob        = $passenger.find('.pd-dob').data('DateTimePicker');

		$passenger.find('.form-control:not(".pd-entrytype,.pd-existingname,.pd-primary,.pd-cruiselineinsurance,.pd-iatacountry")').val('');
		$passenger.find('.pd-iatacountry').val('US');

		if (typeof dob === 'undefined') {
			$passenger.find('.pd-dob').val('');
		} else {
			$passenger.find('.pd-dob').data('DateTimePicker').clear();
		}

		$passenger.find('.pd-passengertitle').empty();
		$passenger.find('.pd-phoneno').empty();
		$passenger.find('.pd-pastpassengerno').empty();

		$passenger.find('.pd-pastpassengernomanual-div').addClass('hidden');
		$passenger.find('.pd-select-pastpassengerno').addClass('hidden');
		$passenger.find('.pd-pastpassengerno-div').removeClass('hidden');

		$passenger.find('.form-control:not(".pd-entrytype,.pd-existingname,.pd-primary")').prop('disabled', true);
		$passenger.find('.btn-radio').addClass('disabled');
	};

}(jQuery, window.Adzuki || {}));
